import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import React from "react";
import es from "react-phone-input-2/lang/es.json";
import { isValidPhoneNumber } from "libphonenumber-js";

const Index = ({ onChange, value, validator }) => {
	const handleChange = (phoneNumber, country) => {
		const phone = phoneNumber.replace(`${country.dialCode}`, "");
		onChange(phone, country);
	};

	const validateNumber = (value, country) => {
		const isValid = isValidPhoneNumber(value, country.iso2.toUpperCase());
		validator(isValid);
		return isValid;
	};

	return (
		<>
			<PhoneInput
				regions={[
					"north-america",
					"south-america",
					"central-america",
					"carribean",
				]}
				countryCodeEditable={false}
				localization={es}
				preferredCountries={["cl", "co", "ar", "pe"]}
				autoFormat={false}
				placeholder="Número de teléfono"
				country={"cl"}
				value={value}
				onChange={(phoneNumber, country) =>
					handleChange(phoneNumber, country)
				}
				isValid={validateNumber}
				inputStyle={{
					fontFamily: "Montserrat",
					border: "none",
					width: "100%",
				}}
				containerStyle={{
					border: "none",
					borderBottom: "1px solid #a2a2a2",
				}}
				buttonStyle={{
					backgroundColor: "transparent",
					border: "none",
				}}
				searchStyle={{
					width: "100%",
				}}
			/>
		</>
	);
};
export default Index;
